/**
 * =============================================================================
 * StatusChip — B-6 shared primitive (ADR-025 §6.2; design-v3 §F)
 * =============================================================================
 *
 * The single home for the config-map → BigDesign <Badge> idiom that was
 * duplicated across the status badges, RFI maps, and the shell launch chip.
 * EXTRACTED from the shipped incumbents — renders exactly the DOM they
 * rendered (`<Badge variant label [aria-label] [data-testid]>`), so every
 * delegating consumer is byte-identical and its suites pass unmodified.
 *
 * Deliberately thin: status→variant mapping stays at each consumer (domain
 * knowledge), aria-label prefixes stay caller-owned (pinned test contracts),
 * and QualityBadge is NOT a consumer (structurally different hand-rolled chip).
 * =============================================================================
 */

import React from 'react';
import { Badge } from '@bigcommerce/big-design';

export type StatusChipVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'danger';

export interface StatusChipProps {
  /** Visible chip text (Badge label). */
  label: string;
  variant: StatusChipVariant;
  /** Optional accessible-name override (e.g. "Reply status: Pending"). */
  ariaLabel?: string;
  /** Forwarded as data-testid. */
  testId?: string;
}

export function StatusChip({ label, variant, ariaLabel, testId }: StatusChipProps): React.ReactElement {
  return <Badge variant={variant} label={label} aria-label={ariaLabel} data-testid={testId} />;
}
